import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MediaDialogPageService } from '@core/services/media-dialog-page.service';
import { TournamentRootService } from '@core/services/tournament-root.service';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Game, MediaItem, Tournament, UntilDestroy } from '@mtgame/core';
import { SeoService } from '@core/services/seo.service';

@UntilDestroy
@Component({
  selector: 'mtg-league-media-detail',
  templateUrl: './league-media-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueMediaDetailComponent implements OnInit, OnDestroy {
  constructor(
    private seoService: SeoService,
    private mediaDialogPageService: MediaDialogPageService,
    private tournamentRootService: TournamentRootService,
  ) {
  }

  ngOnInit(): void {
    this.mediaDialogPageService.media$
      .pipe(take(1))
      .subscribe(media => {
        this.seoService.setData({image: media.originalPhoto.path});
        this.mediaDialogPageService.getGameMedia(media.gameId).then(game => {
          let title = '';
          let description = '';
          if (game.isClosed) {
            const winnerTeam = game.team.id === game.teamWinnerId ? game.team : game.competitorTeam;
            const loserTeam = game.team.id === winnerTeam.id ? game.competitorTeam : game.team;
            if (game.team.sport.isHockey()) {
              description = `Победа ${winnerTeam.name} в игре против ${loserTeam.name}`;
            } else {
              description = `Победа ${winnerTeam.name} в матче против ${loserTeam.name}`;
            }
          }
          if (game.team.sport.isHockey()) {
            title = `Игра ${game.team.name} против ${game.competitorTeam.name}`;
          } else {
            title = `Матч ${game.team.name} против ${game.competitorTeam.name}`;
          }
          this.seoService.setData({
            title,
            description
          });
        });
      });
  }

  ngOnDestroy(): void {
    this.seoService.setData({image: '', title: 'Медиа'});
    this.mediaDialogPageService.dispose();
  }

  get media$(): Observable<MediaItem> {
    return this.mediaDialogPageService.media$;
  }

  get game$(): Observable<Game> {
    return this.mediaDialogPageService.game$;
  }

  get tournament$(): Observable<Tournament> {
    return this.tournamentRootService.tournament$;
  }
}
